<ag-grid-angular
#agGrid
 [headerHeight]="33"
             [rowHeight]="27" 
style="height: 100%;"
class="ag-theme-balham"

[columnDefs]="columnDefs"
[gridOptions]="gridOptions"
[defaultColDef]="defaultColDef"
[maxConcurrentDatasourceRequests]="-1"
[suppressDragLeaveHidesColumns]="true"
(cellClicked)="selectCustomer($event)"
(gridReady)="onGridReady($event)"
[overlayNoRowsTemplate]="overlayNoRowsTemplate"
[getContextMenuItems]="getContextMenuItems"
></ag-grid-angular>
<div class="col-12"><p class="ag-record-row-summary-panel padds text-end">{{totalRecord}}&nbsp;{{translate?.general.messages.records}}</p></div>
